import React, { useState } from "react";

const AvatarImage = ({ src }) => {
  const [loaded, setLoaded] = useState(false);
  const fallback = "/assets/images/logo.png";

  return (
    <>
      {!loaded && <img src={fallback} alt="Fallback" className="p-3" />}
      <img
        src={src || fallback}
        alt="User"
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
        style={loaded ? {} : { display: "none" }}
        referrerPolicy="no-referrer"
      />
    </>
  );
};

export default AvatarImage;
